import { LocationSortMode, LocationSortOption } from '../../location-store';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { Flex, Icon, Th } from '@cad-arc';

interface LocationTableHeaderProps {
    currentSortMode?: LocationSortMode;
    sortOption: LocationSortOption;
    updateSort: (option: LocationSortOption) => void;
    key: string;
    children?: React.ReactNode;
}

export const LocationTableHeader = observer((props: LocationTableHeaderProps) => {
    const { key, currentSortMode, updateSort, sortOption } = props;

    return (
        <Th key={key} onClick={() => updateSort(sortOption)} style={{ userSelect: 'none' }}>
            <Flex alignItems="center">
                {props.children}
                {currentSortMode?.option === sortOption && (
                    <Icon
                        icon={
                            currentSortMode?.direction === 'ASC'
                                ? 'ArrowUpNarrow'
                                : 'ArrowDownNarrow'
                        }
                    />
                )}
            </Flex>
        </Th>
    );
});
